package amazon.lastmile.inject

import app.nestbridge.domain.identity.service.DefaultUserProfileService
import app.nestbridge.domain.identity.service.UserProfileService
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultUserProfileService::class)
public interface AppNestbridgeDomainIdentityServiceDefaultUserProfileService {
  @Provides
  public fun provideDefaultUserProfileServiceUserProfileService(defaultUserProfileService: DefaultUserProfileService): UserProfileService = defaultUserProfileService
}
